import React, { Dispatch, SetStateAction } from 'react';
import { BiChevronRight } from 'react-icons/bi';
import { useSelector } from 'react-redux';

import { Skeleton } from '@material-ui/lab';

import Avatar from '~/components/Avatar';
import { useAuth } from '~/hooks/auth';
import { IState } from '~/store';
import colors from '~/styles/colors';

import {
  Container,
  ExitSpan,
  StyledMenu,
  StyledMenuEmail,
  ProfileOption,
  SignOutOption,
  StyledMenuName,
  StyledMenuUser,
  UserContent,
  EditPasswordBox,
  PasswordOption,
} from './styles';

interface UserDropdownProps {
  ref: React.MutableRefObject<any>;
  user: { name: string; email: string };
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}

const UserDropdown: React.FC<UserDropdownProps> = ({
  user,
  ref,
  setOpenModal,
}) => {
  const { signOut } = useAuth();

  const userProfile = useSelector((state: IState) => state.users.userProfile);

  const loadingGroupsOrProfile = useSelector(
    (state: IState) => state.users.loadingGroupsOrProfile,
  );

  return (
    <Container ref={ref}>
      <UserContent>
        {!loadingGroupsOrProfile ? (
          <Avatar variant="secondary" image={userProfile?.thumbnail ?? ''} />
        ) : (
          <Skeleton
            animation="wave"
            variant="rect"
            style={{ borderRadius: '50%', height: '33px', width: '33px' }}
          />
        )}

        <StyledMenuUser>
          <StyledMenuName>{user.name}</StyledMenuName>
          <StyledMenuEmail>{user.email}</StyledMenuEmail>
          <ProfileOption
            style={{ padding: '0', paddingBottom: '0.571rem' }}
            to="/profile"
          >
            Ver meu perfil
          </ProfileOption>
        </StyledMenuUser>
      </UserContent>
      <EditPasswordBox type="button" onClick={() => setOpenModal(true)}>
        <PasswordOption style={{ padding: '0' }}>Alterar senha</PasswordOption>
        <BiChevronRight
          size={20}
          color={colors.primary}
          style={{ marginTop: '2px' }}
        />
      </EditPasswordBox>
      <StyledMenu onClick={() => signOut()}>
        <SignOutOption to="">
          <ExitSpan>Sair</ExitSpan>
        </SignOutOption>
      </StyledMenu>
    </Container>
  );
};
export default UserDropdown;
